import { useEffect, useRef } from 'react';

import { useRecordOuraImpression } from './use-record-oura-impression';

export type UseOuraImpressionTrackingParams = {
    enabled: boolean;
    prescriberOrderId: string;
};

export const useOuraImpressionTracking = ({
    enabled,
    prescriberOrderId,
}: UseOuraImpressionTrackingParams): void => {
    const recordImpression = useRecordOuraImpression();
    const lastRecordedIdRef = useRef<string | null>(null);

    useEffect(() => {
        if (!enabled) return;
        if (lastRecordedIdRef.current === prescriberOrderId) return;

        lastRecordedIdRef.current = prescriberOrderId;

        try {
            // Fire event to log impression
            void recordImpression(prescriberOrderId).catch(() => undefined);
        } catch {
            // Impression tracking must never break rendering.
        }
    }, [enabled, prescriberOrderId, recordImpression]);
};
